import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import type { ImageColumnProps } from '@modules/page-builder/types';
import { DUO_COLUMN_WIDTH_MD } from '@modules/page-builder/config/column-constants';
import DetailSingleImageShell from '../detail-single-image-shell/DetailSingleImageShell';
import * as S from './DuoImageModule.style';
import TagBar from '../../common/tag-bar/TagBar';
import { DetailPageTagBarContainer } from '../../common/pagebuilder.style';
import type { TagType } from '~/modules/product-tagging/type';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '../../common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail/detail-modules/DetailModules.style';

interface DuoImageModuleProps {
    columns: ImageColumnProps[];
    columnsTags: TagType[];
}

const DuoImageModule = ({ columns, columnsTags }: DuoImageModuleProps) => {
    const { mobile } = useAppDisplayModeContext();

    const { css } = useStyles({
        columns: columns.filter((c) => mobile && c.imageUrl).length,
        mobile,
    });

    return (
        <>
            <div
                className={css(
                    S.DuoImageModuleContainer,
                    ImageModuleExtraSpacing
                )}
            >
                {columns.map((column) => {
                    const isMedium =
                        column.dimension.width >= DUO_COLUMN_WIDTH_MD;
                    const isSmall = !isMedium;
                    if (mobile && !column.imageUrl) {
                        return null;
                    }

                    return (
                        <div
                            key={column.id}
                            className={css(S.DuoImageContainerImage(isMedium))}
                        >
                            {column?.imageUrl && (
                                <DetailSingleImageShell
                                    caption={column.caption}
                                    dimension={column.dimension}
                                    libraryImage={column?.libraryImage}
                                    tags={column.tags}
                                    uniqueApprovedTags={
                                        column.uniqueApprovedTags
                                    }
                                    imageURL={column.imageUrl}
                                >
                                    <ImageWithPaintPicker
                                        src={column.imageUrl}
                                        width={column.dimension.width}
                                        height={column.dimension.height}
                                        layout={'fill'}
                                        objectFit={'cover'}
                                        sizes={
                                            isSmall
                                                ? getImagesSizes(400)
                                                : getImagesSizes(618)
                                        }
                                        alt={
                                            column.caption ||
                                            column?.libraryImage?.Title ||
                                            ''
                                        }
                                    />
                                </DetailSingleImageShell>
                            )}
                        </div>
                    );
                })}
            </div>
            {!mobile && columnsTags.length > 0 && (
                <TagBar
                    className={css(DetailPageTagBarContainer)}
                    tags={columnsTags}
                />
            )}
        </>
    );
};

export default DuoImageModule;
